// @flow
import { alpha } from '../lib/Color';
import Logo from './Logo';
import React from 'react';
import { Fixed, NavItem, Space, Toolbar } from 'rebass';

type propTypes = {
  background: string,
  foreground: string,
};

export default function NavBar({background, foreground}: propTypes) {
  return (
    <Fixed top left right zIndex={1}>
      <Toolbar backgroundColor={alpha(background, 0.95)}>
        <NavItem href="/">
          <Logo
            foreground={foreground}
            mr={1}
            width={40}
          />
          <span style={{color: foreground}}>spoonerism</span>.org
        </NavItem>
        <Space auto={true} />
        <NavItem
          href="https://twitter.com/search?src=typd&q=%23spoonerism"
          target="_blank">
          #spoonerism
        </NavItem>
      </Toolbar>
    </Fixed>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/NavBar.js
 **/